import { track } from '../services/analytics/analytics'
import { useStoredUserList } from './use-stored-user-list'

export interface FeatureInterest {
  on: boolean
  /** The feature's displayed name, for the button's accessible name. */
  name: string
  onToggle: () => void
}

/** The coming-soon features this person asked to hear about, read on mount and written on each toggle. */
export function useFeatureInterest(userId: string): (feature: string, name: string) => FeatureInterest {
  const [asked, setAsked] = useStoredUserList('vt-feature-interest', userId)

  const toggle = (feature: string, on: boolean) => {
    const others = asked.filter((item) => item !== feature)
    setAsked(on ? [...others, feature] : others)
    void track('FEATURE_INTEREST_TOGGLED', { feature, interested: on })
  }

  return (feature, name) => {
    const on = asked.includes(feature)
    return { on, name, onToggle: () => toggle(feature, !on) }
  }
}
